<template>
	<div class="balance-user" :style="{ '--height': height, }">
		<div class="index-view-top">
			<van-icon @click="toBack" name="arrow-left" size="28" color="#ffffff" />
			<div class="title">{{ $t("head.question") }}</div>
			<van-icon style="opacity: 0" name="ellipsis" size="28" color="#ffffff" />
		</div>
		<ul class="infinite-list" v-infinite-scroll="load">
			<div class="notice-item" v-for="(item, index) in problemList" :key="index" @click="toNoticeDetails(item)">
				<div class="left">
					<p>{{ index + 1 }}</p>
				</div>
				<div class="right">
					<div>{{ item.title }}</div>
					<div>
						{{ item.content }}
					</div>
				</div>
			</div>
		</ul>
	</div>
</template>

<script>
import {
	problemList
} from "@/utils/request";
export default {
	data() {
		return {
			problemList: [],
			current: "1",
			size: "10",
			onPullDown: true, //下拉加载
			height: '',//屏幕高度
		};
	},
	created() {
		let h = document.documentElement.clientHeight || document.body.clientHeight;
		if (h > 0) {
			this.height = h + 'px' //页面高度
		} else {
			this.height = "100vh"
		}
		this.baseUrl = BASEURL
		this.looknotice(this.$route.query.item);
	},
	mounted() {
		this.problem();
	},
	methods: {
		problem() {
			var that = this;

			problemList({
				current: that.current,
				size: that.size,
			}).then((res) => {
				if (res.code == "200") {
					that.current = res.data.current
					that.size = res.data.size
					that.problemList = [...that.problemList, ...res.data.records];
					let pages = Math.ceil(res.data.total / that.size);
					if (that.current == pages.toString()) {
						that.onPullDown = false
					}
				}
			});
		},
		toNoticeDetails(item) {
			this.$router.push("/noticeDetails?item=" + JSON.stringify(item));
		},
		load() {
			var that = this
			that.current = (parseInt(that.current) + 1).toString()
			if (that.onPullDown == true) {
				that.problem()
			}
		},
		toBack() {
			this.$router.go(-1);
		},
	},
};
</script>

<style lang="scss" scoped>
.balance-user {
	width: 100vw;
	height: var(--height);
	background: #0c0b0b;

	.infinite-list {
		height: calc(var(--height) - 3.75rem);
		padding: 0 0.9375rem;
		overflow-y: scroll;
		overflow-x: hidden;
	}

	.notice-item {
		padding: 0.9375rem;
		background: #161414;
		border-radius: 0.625rem;
		display: flex;
		align-items: center;
		margin-bottom: 0.9375rem;

		.left {
			display: block;
			width: 10%;
			height: 1.625rem;
			width: 1.625rem;
			min-width: 1.625rem;
			background-image: url("../assets/xx.png");
			background-position: center center;
			background-size: 100% 100%;
			background-repeat: no-repeat;
			display: flex;
			align-items: center;
			justify-content: center;

			>p {
				font-size: 0.6875rem;
				font-family: PingFang SC-Bold, PingFang SC;
				font-weight: bold;
				color: #ffffff;
			}
		}

		.right {
			padding-left: 0.625rem;
			width: 90%;

			>div:nth-child(1) {
				font-size: 0.875rem;
				font-family: PingFang SC-Medium, PingFang SC;
				font-weight: 500;
				color: #ffffff;
				padding-bottom: 0.3125rem;
				overflow: hidden;
				width: 100%;
				white-space: normal;
				word-break: break-all;
			}

			>div:nth-child(2) {
				font-size: 0.75rem;
				font-family: PingFang SC-Medium, PingFang SC;
				font-weight: 500;
				color: #999999;
				overflow: hidden;
				width: 100%;
				white-space: normal;
				word-break: break-all;
			}
		}
	}

	.index-view-top {
		height: 3.625rem;
		padding: 0 0.9375rem;
		display: flex;
		align-items: center;
		justify-content: space-between;

		.title {
			font-size: 1.125rem;
			font-family: PingFang SC-Bold, PingFang SC;
			font-weight: bold;
			color: #ffffff;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/notice/question.vue